import { createSafeContext } from '@/util';

import type { VBaseTableContextValue } from './type';

const VBaseTableContext = createSafeContext<VBaseTableContextValue<any>>();

export default VBaseTableContext;
